export const MINUS_SIGN = '−';

// NOTE: The minus sign '−' is different from the dash '-' sign used in typography.

const isFiniteNumberString = (value: string) => {
  const trimmedValue = value.trim();

  if (trimmedValue.length === 0) {
    return false;
  }

  const numericValue = Number(trimmedValue);
  return Number.isFinite(numericValue);
};

const hasLeadingNegativeSign = (value: string) => /^\s*-(?=\s*[$]?\s*(?:\d|\.(?=\d)))/.test(value);

export type FormatNegative = {
  (value: number): number | string;
  (value: string): string;
};

export const formatNegative = ((value: number | string) => {
  if (typeof value === 'number') {
    return value < 0 ? `${MINUS_SIGN}${Math.abs(value)}` : value;
  }

  if (hasLeadingNegativeSign(value)) {
    return value.replace(/^(\s*)-/, (_match, leadingWhitespace) => `${leadingWhitespace}${MINUS_SIGN}`);
  }

  if (!isFiniteNumberString(value)) {
    return value;
  }

  const numericValue = Number(value.trim());

  if (numericValue < 0) {
    return value.replace(/^(\s*)-/, (_match, leadingWhitespace) => `${leadingWhitespace}${MINUS_SIGN}`);
  }

  return value;
}) as FormatNegative;
